module.exports = __webpack_public_path__ + "static/hero-f0553f95fe0e473b061b40bc4d409744.jpg";